import { Utilities } from "@learningblocks/exp-constants";
const { VISIBILITY, checkIfSelectionValid } = Utilities;
const NEXT_COMPONENT = "nextComponent";

// check if selected Question option correct adn update accordingly
export function submitAnswer(state, payload) {
  return {
    ...state,
    currentChapter: updateSubmissionInCurrentChapter(
      state.currentChapter,
      payload
    ),
  };
}

function updateSubmissionInCurrentChapter(currentChapter, payload) {
  return {
    ...currentChapter,
    components: updateSubmissionInComponents(
      currentChapter.components,
      payload
    ),
  };
}

/**
 *
 * @param {'Array<Object>'} components array of components
 * @param {'number'} payload component ID
 * @returns
 */
function updateSubmissionInComponents(components, payload) {
  const { newcomponents } = components.reduce(
    (acc, component) => {
      // updating submitted MSCQ component
      if (component.id === payload) {
        component = updateMSCQComponent(component);
        if (Object.hasOwn(component, NEXT_COMPONENT)) {
          acc.forward = {
            complete: component.complete,
            nextComponent: component.nextComponent,
          };
        }
      }

      // updating forward component and setting its visibility
      if (
        acc.forward &&
        acc.forward.complete &&
        acc.forward.nextComponent === component.id
      ) {
        component = { ...component, visibility: VISIBILITY.VISIBLE };
        acc.forward = null;
      }

      acc.newcomponents = [...acc.newcomponents, component];
      return acc;
    },
    {
      forward: null,
      newcomponents: [],
    }
  );
  return newcomponents;
}

function updateMSCQComponent(component) {
  if (checkIfSelectionValid(component)) {
    component.checkboxes = component.checkboxes.map(updateSelectedCheckbox);
    component.complete = updateMSCQComplete(
      component.checkboxes,
      component.answerId
    );
    if (component.totalAttempts !== -10) {
      component.totalAttempts -= 1;
    }
  }
  return component;
}

function updateSelectedCheckbox(checkboxOption) {
  if (checkboxOption.selected === true) {
    checkboxOption.disabled = true;
  }
  return { ...checkboxOption };
}

const updateMSCQComplete = (checkboxes, answerId) => {
  const selectedCheckboxes = checkboxes.reduce((selected, option) => {
    // option.disabled means its been submitted.
    if (option.disabled) {
      selected.push(option.id);
    }
    return selected;
  }, []);
  const complete = answerId.every((id) => selectedCheckboxes.includes(id));
  return complete;
};
